import { Skeleton } from '@agro1desenvolvimento/react-components';

const SKELETON_ROWS = [
  { gleba: '55%', badge: '38%', meta: '18%' },
  { gleba: '70%', badge: '42%', meta: '22%' },
  { gleba: '45%', badge: '35%', meta: '20%' },
  { gleba: '62%', badge: '40%', meta: '16%' },
  { gleba: '50%', badge: '36%', meta: '24%' },
];

const NotificacoesSkeleton = () => (
  <table className="notificacoes-lista notificacoes-skeleton">
    <tbody>
      {SKELETON_ROWS.map((row, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={i} className="notificacao-item">
          <td className="notificacao-gleba">
            <Skeleton width={row.gleba} height="0.8rem" />
          </td>
          <td className="notificacao-badge-cell">
            <Skeleton width={row.badge} height="1.35rem" borderRadius="3px" />
          </td>
          <td className="notificacao-meta">
            <Skeleton width={row.meta} height="0.7rem" />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default NotificacoesSkeleton;
